export default __webpack_public_path__ + "static/media/logo-vidalence-logo@3x.760806b3.png";